import {Typography} from '@material-ui/core';
import React from 'react';

type FundingTermSheetProps = {};

const FundingTermSheet = (_props: FundingTermSheetProps) => {
  return (
    <div>
      <div className="title">Funding term sheet</div>
      <>
        <div className="row">
          <div className="col-6">
            <Typography>Funder</Typography>
          </div>
          <div className="col-6">
            <Typography>Select</Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Typography>Amount funded</Typography>
          </div>
          <div className="col-6">
            <Typography>Enter</Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Typography>Cession terms</Typography>
          </div>
          <div className="col-6">
            <Typography>Select</Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Typography>Repayment Period</Typography>
          </div>
          <div className="col-6">
            <Typography>Enter</Typography>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <Typography>Interest rate</Typography>
          </div>
          <div className="col-6">
            <Typography>Enter</Typography>
          </div>
        </div>
      </>
    </div>
  );
};

export default FundingTermSheet;
